module.exports = __webpack_public_path__ + "img/css.55338d57.svg";